

<app-ag-grid-table
  *ngIf="!isLoading && columnDefs"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [columnSelection]="columnSelection"
  [isDynamicEntity]="true"
  [tableParams]="tableParams"
>
</app-ag-grid-table>

<div *ngIf="isLoading">Loading...</div>